<template>
  <t-default-entry-sidebar
    v-if="sidebarInfo"
    :sidebar-list="sidebarInfo.sidebarList"
    :sidebar-current="sidebarInfo.sidebarCurrent"
    :heading="sidebarInfo.heading"
    :sub-heading="sidebarInfo.subHeading"
    :sidebar-heading="sidebarInfo.sidebarHeading"
    :sidebar-sub-heading="sidebarInfo.sidebarSubHeading"
    :class="componentClassName"
    :footer="false"
  >
    <form class="t-walkthrough-select-ivr__form" @submit.prevent="handleSubmitForm">
      <div class="t-walkthrough-select-ivr__description">
        <a-heading tag="h3" size="small">着信フローの設定を行いますか？</a-heading>
        <a-text>
          利用する場合、続けて2つの設定を行います<br />
          1. 分岐ごとの応答設定<br />
          2. 自動音声ガイダンスの設定
        </a-text>
      </div>
      <div class="t-walkthrough-select-ivr__fields">
        <a-radio v-model="enabled" name="enabled-ivr" variant="button" value="1" label="設定する" />
        <a-radio v-model="enabled" name="enabled-ivr" variant="button" value="0" label="設定しない" />
      </div>
      <div class="t-walkthrough-select-ivr__instruction">
        <a-alert title="COTOHA Call Centerの着信フローとは？">
          <a-text>
            自動音声ガイダンスで最初にお客様の要件を伺い、担当者に電話を繋ぐ機能です。例えば、「営業電話は1、問合せ内容は2」と割り振ると、お客様が押したプッシュ番号に応じて、事前に設定した担当者のみが着電するよう設定できます。外部の回線に電話を転送することも可能です。
          </a-text>
          <figure class="t-walkthrough-select-ivr__instruction-image">
            <img src="@/images/walkthrough/select-ivr.svg" />
          </figure>
        </a-alert>
      </div>
      <div class="t-walkthrough-select-ivr__buttons">
        <m-button-container>
          <a-button variant="block" submit="submit" color="primary">次へ</a-button>
          <a-button variant="outlined" color="primary" @click="handleCancelClick">戻る</a-button>
          <a-button color="primary" class="t-walkthrough-select-ivr__button-optional" @click="handleNotSettingClick"
            >初期設定はせずにホーム画面へ</a-button
          >
        </m-button-container>
      </div>
    </form>
  </t-default-entry-sidebar>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import TDefaultEntrySidebar from '@/components/templates/default-entry-sidebar';
import AAlert from '@/components/atoms/alert';
import AHeading from '@/components/atoms/heading';
import ARadio from '@/components/atoms/radio';
import AButton from '@/components/atoms/button';
import AText from '@/components/atoms/text';
import MButtonContainer from '@/components/molecules/button-container';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';

export default {
  name: 't-walkthrough-select-ivr',
  components: {
    TDefaultEntrySidebar,
    AAlert,
    AHeading,
    ARadio,
    AButton,
    AText,
    MButtonContainer,
  },
  mixins: [customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    // sidebarInfo: {
    //   type: Object,
    //   default: null,
    // },
    // handleFormSubmit: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleCancelClick: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleNotSettingClick: {
    //   type: Function,
    //   default: () => {},
    // },
  },
  data() {
    return {
      enabled: '1',
      sidebarInfo: {
        sidebarList: [
          { label: 'ユーザー招待' },
          {
            label: '営業時間設定',
            subStepLabel: '営業時間設定する場合',
            steps: ['営業時間設定', '営業時間外対応方法設定', '休憩時間対応方法設定'],
          },
          { label: '着信フローの設定' },
        ],
        sidebarCurrent: 3,
        heading: '着信フローの設定',
        subHeading: 'Step 3',
        sidebarSubHeading: 'Walk Through',
        sidebarHeading: '初期設定',
      },
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-walkthrough-select-ivr');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  methods: {
    handleSubmitForm(e) {
      e.preventDefault();
      this.handleFormSubmit(this.enabled === '1');
    },
    handleFormSubmit(isIVR) {
      //console.log('着信フローの設定');
      // console.log(isIVR);
      if (isIVR) {
        this.$router.push({ name: 'WTRoutingUserGroup' });
      } else {
        this.$router.push({ name: 'WTIvrUserGroup' });
      }
    },
    handleCancelClick() {
      this.$router.push({ name: 'WTSelectBusinessHours' });
    },
    handleNotSettingClick() {
      this.updateFirstVisitFlag();
      this.$router.push({ name: 'Home' });
    },
    updateFirstVisitFlag(status = false) {
      this.postRequest('/walkthrough/update-firstVisitFlag', { status })
        .then(res => {
          if (res.status === 'success') {
            //console.log('firstVisitFlag is updated to', status);
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('検索'));
        });
    },
  },
};
</script>
